import $ from 'jquery';
import jQuery from 'jquery';

// Make jQuery available globally
window.$ = $;
window.jQuery = jQuery;

